import { render, staticRenderFns } from "./RetailBackList.vue?vue&type=template&id=491e2388&scoped=true"
import script from "./RetailBackList.vue?vue&type=script&lang=js"
export * from "./RetailBackList.vue?vue&type=script&lang=js"
import style0 from "./RetailBackList.vue?vue&type=style&index=0&id=491e2388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491e2388",
  null
  
)

export default component.exports